export const filterNormalizedWithoutAccentToSelectComponent = (input: string, option: any) => {
    const value = option.label ?? option.title ?? option.children ?? '';
    return (
        value
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .indexOf(
                input
                    .toLowerCase()
                    .normalize('NFD')
                    .replace(/[\u0300-\u036f]/g, '')
            ) >= 0
    );
};

const normalizeText = (text: unknown) =>
    (typeof text === 'string' ? text : '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');

export const filterGroupedCategories = (input: string, option: any) => {
    const normalizedInput = normalizeText(input);
    const categoryName = option.label ?? option.children ?? '';
    const groupName = option.groupLabel ?? '';

    return (
        normalizeText(categoryName).indexOf(normalizedInput) >= 0 ||
        normalizeText(groupName).indexOf(normalizedInput) >= 0
    );
};